import request from '@/utils/request'

export function methodPost(url, params) {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}
export function methodGet(url, query) {
  return request({
    url: url,
    method: 'get',
    params: query
  })
}




// WEBPACK FOOTER //
// ./src/api/coupon.js